import { useCallback } from 'react';
import { sdk } from 'sdk';

const useAfd = () => {
  const getAddressList = useCallback(async (postCode: string) => {
    const payload = {
      postCode,
    };
    const response = await sdk.callAction({
      actionName: 'afd/getAddressList',
      payload: payload,
    });

    return response.isError ? { Result: -5, ErrorText: 'service-error' } : response.data;
  }, []);

  const getAddressDetails = useCallback(async (key: string) => {
    const payload = {
      key,
    };
    const response = await sdk.callAction({
      actionName: 'afd/getAddressDetails',
      payload: payload,
    });

    return response.isError ? { Result: -5, ErrorText: 'service-error' } : response.data;
  }, []);

  return { getAddressList, getAddressDetails };
};

export default useAfd;
